import { Component, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '@partners/ui';

@Component({
  selector: 'alert-icon',
  standalone: true,
  imports: [IconComponent],
  template: `
    <icon iconName="ico-rounded--alert" iconVariant="rounded" iconSize="lg" />
  `,
  styles: ``,
  encapsulation: ViewEncapsulation.None
})
export class AlertIconComponent {}
